export default {
  postagePageTitle: '店铺级运费设置'
}
